import { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { Field } from 'formik';
import { useAppSelector } from 'store/hooks/useAppSelector';
import { getIsReadonlySelector } from 'store/selectors/auth';
import { t } from 'ttag';

import { ChangeScreenSection } from 'components/common/ChangeScreenSection';
import { FieldInput } from 'components/common/FieldInput';

import { styles } from './styles';

export const AdditionsDataTabPickUpTime: FC = () => {
  const readOnly = useAppSelector(getIsReadonlySelector);

  return (
    <ChangeScreenSection label={t`Pickup time and ferry cost`}>
      <Grid container columns={1} rowGap={2}>
        <Grid container columns={1} spacing={2} rowGap={4}>
          <Grid item mobile={1} sx={styles.gridItem}>
            <Field
              component={FieldInput}
              name="pickWaitingTime"
              label={t`Waiting time pickup`}
              placeholder={t`Enter waiting time pickup`}
              type="number"
              disabled={!!readOnly}
            />
            <Typography>{t`min`}</Typography>
          </Grid>
          <Grid item mobile={1} sx={styles.gridItem}>
            <Field
              component={FieldInput}
              name="pickLoadingTime"
              label={t`Loading time`}
              placeholder={t`Enter loading time`}
              type="number"
              disabled={!!readOnly}
            />
            <Typography>{t`min`}</Typography>
          </Grid>
          <Grid item mobile={1} sx={styles.gridItem}>
            <Field
              component={FieldInput}
              name="ferryAdditionCostPickup"
              label={t`Ferry addition cost`}
              placeholder={t`Enter ferry addition cost`}
              type="number"
              disabled={!!readOnly}
            />
            <Typography>{t`kr`}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </ChangeScreenSection>
  );
};
